import {
    LegalObjectType,
    PhysicalObjectType,
} from '../../../providers/ActivationObjectProvider/types'
import { GenericDropdownItem } from '../../../../types'
import { WizzardStep2Form } from '../types'

export const DefaultValue: WizzardStep2Form = {
    guaranteedArrivalTime: 0,
    handoverDate: undefined,
    handoverHour: undefined,
    backHandoverDate: undefined,
    backHandoverHour: undefined,
    selectService: undefined,
    destroyKey: null,
}

export const PhysicalObjectTypeDesc: Record<PhysicalObjectType, string> = {
    FamilyHouse: 'Rodinný dům',
    Flat: 'Byt',
    Another: 'Jiný',
}

export const PhysicalObjectTypeList: GenericDropdownItem<PhysicalObjectType>[] =
    Object.keys(PhysicalObjectTypeDesc).map((key) => {
        return {
            value: key as PhysicalObjectType,
            label: (PhysicalObjectTypeDesc as any)[key],
        }
    })

export const LegalObjectTypeDesc: Record<LegalObjectType, string> = {
    FamilyHouse: 'Rodinný dům',
    Flat: 'Byt',
    Shop: 'Prodejna',
    Office: 'Kancelář',
    Another: 'Jiný',
}

export const LegalObjectTypeList: GenericDropdownItem<LegalObjectType>[] =
    Object.keys(LegalObjectTypeDesc).map((key) => {
        return {
            value: key as LegalObjectType,
            label: (LegalObjectTypeDesc as any)[key],
        }
    })

export const ObjectDescriptionHelper: Record<
    PhysicalObjectType | LegalObjectType,
    string
> = {
    FamilyHouse:
        'počet podlaží, barva fasády, typ a barva střechy, typ a barva oplocení',
    Flat: 'číslo bytu, patro, umístění na patře, popis vstupních dveří ',
    Another:
        'účel objektu, barva fasády, počet podlaží, typ a barva střechy, typ a barva oplocení',
    Shop: 'název prodejny, barva fasády, počet a barva přístupových dveří',
    Office: 'barva fasády, počet a barva přístupových dveří, číslo/označení dveří',
}
